import React, {useCallback, useEffect, useState} from "react";
import {CFValue} from 'module/CustomField/type/CFType'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {stripHTML} from 'util/StringUtil'
import {css} from '@emotion/react'
import {cssCFInput} from 'module/CustomField/style/cssCFInput'

export function CustomFieldPasswordComponent({modelValue, disabled, placeholderHTML, setCb}: CFComponentProps<CFValue>) {
	const [viewValue, setViewValue] = useState<CFValue>(modelValue);
	const cssPassword = css`
		text-security: disc;
		-webkit-text-security: disc;
		-moz-text-security: disc;
	`
	useEffect(() => {
		setViewValue(modelValue);
	}, [modelValue])

	return (
		<div>
			<input
				css={[cssCFInput, cssPassword]}
				disabled={disabled}
				placeholder={stripHTML(placeholderHTML)}
				onChange={evt => setViewValue(evt.target.value)}
				value={viewValue || ''}
				onFocus={(evt) => evt.target.select()}
				onBlur={() => {
					setViewValue(modelValue);
					if (!disabled) {
						setCb(viewValue);
					}
				}}
			/>
		</div>
	)
}